// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1At6m","type":"styles_type__2B23M","choices":"styles_choices__17oEs"};